/**
 * <s-gallery-carousel> — product gallery carousel
 * Scrolls its [data-product-gallery] track one slide at a time and keeps the
 * slide counter current. Driven by Invoker Commands on the element itself.
 *
 * Commands:
 *   --prev — scroll one slide back
 *   --next — scroll one slide forward
 */
class SGalleryCarousel extends HTMLElement {
  #ac;
  #track;
  #current;

  connectedCallback() {
    this.#track = this.querySelector('[data-product-gallery]');
    this.#current = this.querySelector('[data-carousel-current]');
    if (!this.#track) return;
    this.#ac = new AbortController();
    const { signal } = this.#ac;

    this.addEventListener('command', (event) => {
      if (event.command === '--next') this.#go(1);
      if (event.command === '--prev') this.#go(-1);
    }, { signal });

    this.#track.addEventListener('scroll', () => this.#update(), { signal, passive: true });
    this.#update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #index() {
    const width = this.#track.clientWidth || 1;
    return Math.round(this.#track.scrollLeft / width);
  }

  #go(step) {
    const count = this.#track.children.length;
    let next = this.#index() + step;
    if (next < 0) next = count - 1;
    if (next >= count) next = 0;
    const smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollTo({ left: next * this.#track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
  }

  #update() {
    if (this.#current) this.#current.textContent = String(this.#index() + 1);
  }
}

if (!customElements.get('s-gallery-carousel')) customElements.define('s-gallery-carousel', SGalleryCarousel);
